export function createQuestionViewIndexMapping(quizArr = []) {
  if (!Array.isArray(quizArr) || quizArr.length <= 0) {
    return null;
  }

  const questionViewIndexMapping = {};
  quizArr.forEach((viewObj, index) => {
    questionViewIndexMapping[viewObj.questionViewId] = index;
  });

  //console.log(questionViewIndexMapping);
  return questionViewIndexMapping;
}
